import React from "react";
import PageFrame from "./PageFrame";
import { ASSETS } from "../lib/brand";

function ParagraphList({ body }) {
    const paragraphs = body.split("\n\n");
    return (
        <div className="space-y-6 text-ink/90 leading-relaxed text-lg">
            {paragraphs.map((p, i) => (
                // Source body is static content with no reordering — text is a stable key here.
                <p key={p.slice(0, 24)} className={i === 0 ? "drop-cap" : ""}>
                    {p}
                </p>
            ))}
        </div>
    );
}

function ComparisonTable({ headers, rows }) {
    return (
        <div className="overflow-x-auto border border-hairline">
            <table className="w-full text-sm">
                <thead className="bg-navy text-cream">
                    <tr>
                        {headers.map((h) => (
                            <th
                                key={h}
                                className="text-left font-sans font-semibold tracking-[0.12em] uppercase text-[10px] px-4 py-4"
                            >
                                {h}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, ri) => (
                        // First cell is a stable category label (e.g., "Vibe", "Median Home Price").
                        <tr key={row[0]} className={ri % 2 === 0 ? "bg-white" : "bg-sand/60"}>
                            {row.map((cell, ci) => {
                                const isHeader = ci === 0;
                                const className = isHeader
                                    ? "px-4 py-4 align-top border-t border-hairline font-sans font-semibold text-navy text-[11px] tracking-[0.1em] uppercase"
                                    : "px-4 py-4 align-top border-t border-hairline text-ink/85";
                                return (
                                    <td key={`${row[0]}-${headers[ci]}`} className={className}>
                                        {cell}
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default function WelcomePage({ welcome, comparison, pageNum, totalPages }) {
    return (
        <PageFrame pageNum={pageNum} totalPages={totalPages} label="Welcome">
            <div className="max-w-6xl mx-auto px-6 sm:px-10 lg:px-16 py-16 sm:py-24 w-full">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-7">
                        <div className="eyebrow">The Emerald Coast</div>
                        <h2 className="serif-display text-5xl sm:text-6xl text-navy mt-4 mb-8">
                            {welcome.title}
                        </h2>
                        <ParagraphList body={welcome.body} />
                    </div>
                    <div className="lg:col-span-5 lg:pt-8">
                        <div className="aspect-[4/5] overflow-hidden border border-hairline">
                            <img
                                src={ASSETS.welcomeImage}
                                alt="Emerald Coast"
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <div className="eyebrow mt-4 text-muted2" style={{ color: "#5C6B73" }}>
                            Okaloosa · Santa Rosa · Walton
                        </div>
                    </div>
                </div>

                <div className="mt-20">
                    <div className="eyebrow">At-a-Glance</div>
                    <h3 className="serif-display text-3xl sm:text-4xl text-navy mt-3 mb-8">
                        Six-City Comparison
                    </h3>
                    <ComparisonTable headers={comparison.headers} rows={comparison.rows} />
                </div>
            </div>
        </PageFrame>
    );
}
